export interface ISplitExpensePromptParams {
  title?: string;
  amount?: number;
  currencySymbol?: string;
  date?: string;
  payerName?: string;
  isCurrentUserPayer?: boolean;
}

const introMessage = 'How do you want to split';

const buildAmount = (amount?: number, currencySymbol: string = '$') => {
  if (!amount || amount <= 0) {
    return '';
  }

  return `${currencySymbol}${amount}`;
};

const buildExpenseLabel = ({
  title,
  amount,
  currencySymbol,
}: Pick<ISplitExpensePromptParams, 'title' | 'amount' | 'currencySymbol'>) => {
  const formattedAmount = buildAmount(amount, currencySymbol);

  if (formattedAmount && title) {
    return `the ${formattedAmount} ${title}`;
  }

  if (title) {
    return `the ${title}`;
  }

  if (formattedAmount) {
    return `the ${formattedAmount} expense`;
  }

  return 'the expense';
};

const buildPayerText = ({
  payerName,
  isCurrentUserPayer,
}: Pick<ISplitExpensePromptParams, 'payerName' | 'isCurrentUserPayer'>) => {
  if (!payerName) {
    return '';
  }

  if (isCurrentUserPayer) {
    return 'that you paid';
  }

  return `that ${payerName} paid`;
};

const buildDateText = (date?: string) => {
  if (!date) {
    return '';
  }

  return `on ${date}`;
};

export const createSplitExpensePrompt = (params: ISplitExpensePromptParams) => {
  const {
    title,
    amount,
    currencySymbol = '$',
    date,
    payerName,
    isCurrentUserPayer,
  } = params;

  const expenseLabel = buildExpenseLabel({
    title,
    amount,
    currencySymbol,
  });

  const payerText = buildPayerText({
    payerName,
    isCurrentUserPayer,
  });

  const dateText = buildDateText(date);

  const sentenceParts = [
    introMessage,
    expenseLabel,
    payerText,
    dateText,
  ].filter(Boolean);

  return `${sentenceParts.join(' ')}?`;
};
